import { apiErrorCode } from "../../components/timetable/runErrors";

// The federated sign-in endpoints refuse a login with 403 {detail, code}.
// Branch on the code — the detail is untranslated English, and the callback
// page used to render it straight into a Kazakh or Russian UI ("Your account
// has no email address…").
//
// Same contract as slotErrors.js and components/timetable/runErrors.js; a
// separate map because the vocabularies are disjoint.

// code -> i18n key. Mirrors the `LoginRefused(…, code)` raises in the backend's
// identity/login.py. Extend the map when the backend grows a code; an unmapped
// one still reads, because the server's prose is the fallback.
const CODE_KEYS = {
  bad_state: "auth.federated.refused.badState",
  connection_inactive: "auth.federated.refused.connectionInactive",
  no_active_membership: "auth.federated.refused.noActiveMembership",
  no_email: "auth.federated.refused.noEmail",
  email_collision: "auth.federated.refused.emailCollision",
  no_account: "auth.federated.refused.noAccount",
  unmapped_school: "auth.federated.refused.unmappedSchool",
  provisioning_failed: "auth.federated.refused.provisioningFailed",
  inactive_account: "auth.federated.refused.inactiveAccount",
};

/**
 * Localized message for a refused federated sign-in.
 *
 * `params` carries `provider` — the name on the button the person pressed —
 * for the messages that send them back to that provider to fix something.
 * Only a refusal (403) falls back to the server's own prose: anything else is
 * an outage or a network error, and `fallback` says that better.
 */
export function federatedRefusalMessage(err, t, fallback, params) {
  const key = CODE_KEYS[apiErrorCode(err)];
  if (key) return t(key, params);
  const detail = err?.response?.data?.detail;
  if (err?.response?.status === 403 && typeof detail === "string" && detail) {
    return detail;
  }
  return fallback;
}
